import sjcl from 'sjcl'

$(document).ready(() => {
    let url = location.href.replace(/\/$/, "");

    if (location.hash) {
        const hash = url.split("#");
        $('.panel-tabs a[href="#' + hash[1] + '"]').tab("show");
        url = location.href.replace(/\/#/, "#");
        history.replaceState(null, null, url);
    }

    $('a[data-toggle="tab"]').on("click", function () {
        let newUrl;
        const hash = $(this).attr("href");

        newUrl = url.split("#")[0] + hash;

        newUrl += "/";
        history.replaceState(null, null, newUrl);
    });


    $('body').on('click', '.delete-confirm', function () {
        let url = $(this).data('url');
        Swal.fire({
            title             : 'Ste si istý?',
            text              : "Potvrdením sa vybraná položka odstráni!",
            icon              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor : '#d33',
            confirmButtonText : 'Áno, odstrániť!'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire(
                    'Odstránené!',
                    'Vybraná položka bola odstránená.',
                    'success'
                )
                window.location.replace(url);
            }
        })
    });

    $('body').on('click', '.pin-confirm', function () {
        const url         = $(this).data('route');
        const method      = $(this).data('method') ?? 'POST';
        const hashedPin   = $('meta[name="user-pin"]').attr('content');
        const successText = $(this).data('success-text') ?? "Hodnoty z inventúry sa zapisujú do skladu.";

        Swal.fire({
            position           : 'center',
            title              : 'Potvrdenie pin-om',
            text               : 'Táto operácia je chránená PIN-om. Zadajte prosím Váš pin pre pokračovanie.',
            icon               : 'warning',
            input              : 'text',
            inputAttributes    : {
                autocapitalize: 'off'
            },
            showCancelButton   : true,
            allowOutsideClick  : true,
            allowEscapeKey     : true,
            allowEnterKey      : false,
            backdrop           : 'rgba(0, 0, 0, 0.8)',
            confirmButtonText  : 'Potvrdiť',
            showLoaderOnConfirm: true,
            preConfirm         : (pin) => {
                const myBitArray = sjcl.hash.sha256.hash(pin);
                const pinToCheck = sjcl.codec.hex.fromBits(myBitArray)

                console.log(pinToCheck, hashedPin);

                // if (pin.toString() === pinToCheck.toString()) {
                if (pinToCheck.toString() === hashedPin.toString()) {
                    Swal.fire({
                        icon : 'success',
                        title: 'Zapisovanie údajov',
                        text : successText,
                    })

                    let form              = document.createElement('form');
                    form.style.visibility = 'hidden'; // no user interaction is necessary
                    form.method           = method; // forms by default use GET query strings
                    form.action           = url;

                    let input   = document.createElement('input');
                    input.name  = '_token';
                    input.value = $('meta[name="csrf-token"]').attr('content');
                    form.appendChild(input); // add key/value pair to form

                    document.body.appendChild(form); // forms cannot be submitted outside of body
                    form.submit(); // send
                } else {
                    Swal.showValidationMessage(`Nesprávny PIN.`)
                }
            }
        });
    });

    $('.notification-alert').click(function () {
        let title = $(this).attr('title');
        Swal.fire({
            icon : 'error',
            title: 'Chyba ...',
            text : title,
        })
    });
});
